import React from "react";
import cntl from "cntl";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import { budgetTypesOptions } from "../../../constants";
import PrimaryButton from "../Buttons/PrimaryButton";
import TertiaryButton from "../Buttons/TertiaryButton";
import Widget from "../Widget/Widget";
import ActivateBudgetTable from "../BudgetTable/ActivateBudgetTable";
import useActivateProjectForm from "./useActivateProjectForm";

const primaryButtonCN = (className) => cntl`
  rounded-md
  ${className ?? "ml-3"}
`;

const teritiaryButtonCN = (className) => cntl`
  rounded-md
  capitalize
  ${className}
`;

const ActivateProjectForm = ({
  projectId,
  setActivateProjectModal,
  onActivateProjectCallback,
}) => {
  const {
    projectBudget,
    isActivateFormValid,
    onChangeBudgetType,
    onActivateProjectSubmit,
    onReturnToBudgetView,
    setDraftBudgetLineItems,
  } = useActivateProjectForm({
    projectId,
    setActivateProjectModal,
    onActivateProjectCallback,
  });

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-col">
          <div className="font-es-semibold text-es-lg">
            Activate Project Budget
          </div>
          <div className="font-es-medium text-es-normal tracking-es-wide py-2">
            Choose budget type and reconcile ranges
          </div>
        </div>
        <div className="flex flex-row justify-between pt-2">
          <div className="w-72">
            <Dropdown
              labelClassName="items-center"
              options={budgetTypesOptions}
              value={budgetTypesOptions?.find(
                (type) => type.value === projectBudget?.budgetType
              )}
              onChange={onChangeBudgetType}
            />
          </div>

          <div className="flex flex-row">
            <PrimaryButton
              className={primaryButtonCN()}
              title="Activate"
              background="primaryGreen"
              onClick={() => {
                onActivateProjectSubmit();
              }}
              border="primaryGreen"
              fontColor="white"
              saveButton
              saveButtonTitle="Activate"
              disabled={!isActivateFormValid}
              onKeyUp={() => {
                onActivateProjectSubmit();
              }}
              name="primaryButton"
            />
            <TertiaryButton
              title="Cancel"
              onClick={() => setActivateProjectModal(false)}
              className={teritiaryButtonCN("ml-2")}
              name="tertiaryButton"
              onKeyUp={(event) => {
                if (event.keyCode === 13) {
                  setActivateProjectModal(false);
                }
              }}
            />
          </div>
        </div>
        <Widget draggable={false} title={null} overflow hideBorder padding={-2}>
          <ActivateBudgetTable
            projectId={projectId}
            isActivateProject
            setDraftBudgetLineItems={setDraftBudgetLineItems}
            onReturnToBudgetView={onReturnToBudgetView}
            disbaleRowActions
          />
        </Widget>
      </div>
    </>
  );
};

ActivateProjectForm.propTypes = {
  projectId: PropTypes.string,
  onActivateProjectCallback: PropTypes.func,
  setActivateProjectModal: PropTypes.func,
};

ActivateProjectForm.defaultProps = {
  projectId: undefined,
  onActivateProjectCallback: undefined,
  setActivateProjectModal: undefined,
};

export default ActivateProjectForm;
